module.exports = __webpack_public_path__ + "static/media/agency-halotop.cb3204f4.png";